import React, { useState } from "react";
import "./menu.css";

import alarme from "../../../assets/mobile/icones/alarme.png";
import agenda from "../../../assets/mobile/icones/agenda.png";
import sobre from "../../../assets/mobile/icones/sobre.png";
import sair from "../../../assets/mobile/icones/sair.png";

function Menu({ trocarPagina, paginaAtual }) {
    const [mostrarMaisOpcoes, setMostrarMaisOpcoes] = useState(false);

    const maisOpcoes = () => {
        setMostrarMaisOpcoes(!mostrarMaisOpcoes);
    };

    return (
        <nav className="menu-mobile">
            <div id="barraDeOpções-mobile">
                <div id="barraDeOpções-Botoes-mobile">
                    <button
                        className={`btn-mobile${paginaAtual === "Térreo" ? "-active" : ""}`}
                        onClick={() => { trocarPagina("Térreo"); if (mostrarMaisOpcoes) maisOpcoes(); }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" height="25" viewBox="0 0 24 24">
                            <path d="M 12 2.0996094 L 1 12 L 4 12 L 4 21 L 11 21 L 11 15 L 13 15 L 13 21 L 20 21 L 20 12 L 23 12 L 12 2.0996094 z M 12 4.7910156 L 18 10.191406 L 18 11 L 18 19 L 15 19 L 15 13 L 9 13 L 9 19 L 6 19 L 6 10.191406 L 12 4.7910156 z"></path>
                        </svg>
                    </button>
                    <button
                        className={`btn-mobile${paginaAtual === "Agendamentos" ? "-active" : ""}`}
                        onClick={() => { trocarPagina("Agendamentos"); if (mostrarMaisOpcoes) maisOpcoes(); }}
                    >
                        <img src={agenda} style={{ width: 25 }} alt="Agendamentos" />
                    </button>
                    <button
                        className={`btn-mobile${paginaAtual === "Gestao" ? "-active" : ""}`}
                        onClick={() => { trocarPagina("Gestao"); if (mostrarMaisOpcoes) maisOpcoes(); }}
                        >
                        <img src={alarme} style={{ width: 25 }} alt="Alarme" />
                        </button>
                        <button
                            className={`btn-mais-mobile${paginaAtual === "Sobre" ? "-active" : ""}`}
                            onClick={() => { trocarPagina("Sobre"); maisOpcoes(); }}
                        >
                            <img src={sobre} style={{ width: 25 }} alt="Sobre" />
                        </button>
                        <button
                            className={`btn-mais-mobile${paginaAtual === "Sair" ? "-active" : ""}`}
                            onClick={() => { trocarPagina("Sair"); maisOpcoes(); }}
                        >
                            <img src={sair} style={{ width: 25 }} alt="Sair" />
                        </button>

                    {/*!mostrarMaisOpcoes && (
                        <button
                            id="btn-more-mobile"
                            className={`btn-mobile${mostrarMaisOpcoes || isOpcaoAdicionalAtiva ? "-active" : ""}`}
                            onClick={maisOpcoes}
                        >
                            <p id="text-mais-mobile-inverso">☰</p>
                        </button>
                    )*/}
                    
                </div>
            </div>
            {/*
            <div className={`maisOpcoes${mostrarMaisOpcoes ? "-ativo" : ""}`}>
                {mostrarMaisOpcoes && (
                    <>
                        <button
                            id="btn-more-mobile-inverso"
                            className={`btn-mais-mobile${mostrarMaisOpcoes ? "-active" : ""}`}
                            onClick={maisOpcoes}
                        >
                            <p>☰</p>
                        </button>
                        <button
                        className={`btn-mobile${paginaAtual === "Alarme" ? "-active" : ""}`}
                        onClick={() => { trocarPagina("Alarme"); if (mostrarMaisOpcoes) maisOpcoes(); }}
                        >
                        <img src={alarme} style={{ width: 25 }} alt="Alarme" />
                        </button>
                        <button
                            className={`btn-mais-mobile${paginaAtual === "Sobre" ? "-active" : ""}`}
                            onClick={() => { trocarPagina("Sobre"); maisOpcoes(); }}
                        >
                            <img src={sobre} style={{ width: 25 }} alt="Sobre" />
                        </button>
                        <button
                            className={`btn-mais-mobile${paginaAtual === "Sair" ? "-active" : ""}`}
                            onClick={() => { trocarPagina("Sair"); maisOpcoes(); }}
                        >
                            <img src={sair} style={{ width: 25 }} alt="Sair" />
                        </button>
                    </>
                )}
            </div>
            */}
        </nav>
    );
}

export default Menu;